"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.destory = exports.default = void 0;

require("core-js/modules/es6.number.constructor");

var _constants = require("../constants");

// 捕获项目使用频度
var isH5 = /Truck Alliance/i.test(window.navigator.userAgent) || window.WLAuth;
var hasRefreshed = false;
var existOtherTab = false;

if (!isH5) {
  // 获取存在tab数量、将tabNum加1
  var tabNum = Number(localStorage[_constants.TOTAL_TAB_NUM] || 0);
  existOtherTab = Boolean(tabNum);
  localStorage[_constants.TOTAL_TAB_NUM] = tabNum + 1; // 当前页面是否刷新过

  if (window.sessionStorage[_constants.TOTAL_TAB_NUM]) {
    hasRefreshed = true;
  } else {
    window.sessionStorage[_constants.TOTAL_TAB_NUM] = true;
  }
}

var _default = function _default() {
  return isH5 || !existOtherTab && !hasRefreshed ? {
    data: {},
    name: _constants.METRIC_USE_FREQUENCY,
    type: _constants.METRIC_COUNTER_TYPE
  } : null;
}; // 销毁TOTAL_TAB_NUM


exports.default = _default;

var destory = function destory() {
  if (isH5) return;
  var tabNum = Number(localStorage[_constants.TOTAL_TAB_NUM]);

  if (tabNum < 1 || tabNum === 1) {
    localStorage.removeItem(_constants.TOTAL_TAB_NUM);
  } else {
    localStorage[_constants.TOTAL_TAB_NUM] = tabNum - 1;
  }
};

exports.destory = destory;